export const UNAUTHORIZED_REQUEST_MESSAGE = 'Your session has expired.';
export const REDUX_STORE_NOT_SET_MESSAGE =
    'Koddi API: It looks like you forgot to call `setStore` be sure to call `setStore` before your app is initialized.';
export const NO_ACCESS_MESSAGE =
    'You do not have permission to access this resource.';
export const ATTEMPTING_TO_CHANGE_REDUX_STORE_MESSAGE =
    'KoddiAPI: It appears you are trying to change the KoddiAPI store after it has already been set. That may cause unintended side effects.';
